import { render, staticRenderFns } from "./PlayerInfo.vue?vue&type=template&id=3b336ffe&scoped=true&"
import script from "./PlayerInfo.vue?vue&type=script&lang=js&"
export * from "./PlayerInfo.vue?vue&type=script&lang=js&"
import style0 from "./PlayerInfo.vue?vue&type=style&index=0&id=3b336ffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b336ffe",
  null
  
)

export default component.exports